var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3261 31.6184C21.8776 32.0669 21.2888 32.2923 20.7 32.2923C20.1112 32.2923 19.5224 32.0669 19.0739 31.6184L9.8739 22.4184C8.9746 21.5191 8.9746 20.0655 9.8739 19.1662C10.7732 18.2669 12.2268 18.2669 13.1261 19.1662L20.7 26.7401L39.905 7.53509C35.7029 2.96959 29.6953 0.0922852 23 0.0922852C10.2971 0.0922852 0 10.3894 0 23.0923C0 35.7952 10.2971 46.0923 23 46.0923C35.7029 46.0923 46 35.7952 46 23.0923C46 18.7568 44.7787 14.7157 42.6926 11.2519L22.3261 31.6184Z",
    fill: "#2898A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.a4e8ea67aea495cf20e320252054b463.svg";
export { ForwardRef as ReactComponent };